"use client"

import { useState, useRef, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import { EffectCoverflow, Pagination, Autoplay } from "swiper/modules"
import { useNavigate } from 'react-router-dom' 
import "swiper/css"
import "swiper/css/effect-coverflow"
import "swiper/css/pagination"
import "swiper/css/autoplay"
import "./Offerings.css"
import st from '../../assets/S.jpg'
import ser from '../../assets/R.jpg'
import rev from '../../assets/E.jpg'
import imp from '../../assets/I.jpg'
import PE from '../../assets/P.jpg'
import bus from '../../assets/B.jpg'
import ocm from '../../assets/O.jpg'
import AS from '../../assets/em.jpg'
import EM from '../../assets/AS.jpg'

const carouselData = [
  { id: 1, image: bus, title: "Business Diagnostics", description: "Strategic assessment" },
  { id: 2, image: st, title: "Strategic Consulting", description: "Development & execution" },
  { id: 3, image: ser, title: "Readiness Assessment", description: "Optimization solutions" },
  { id: 4, image: imp, title: "Implementation Service", description: "Management strategies" },
  { id: 5, image: rev, title: "Reverse Engineering Engagements", description: "Transformation leadership" },
  { id: 6, image: ocm, title: "Organizational Change Management", description: "Hands-on execution" },
  { id: 7, image: PE, title: "Performance Engineering Services", description: "Operational excellence" },
  { id: 8, image: AS, title: "Additional Service Capabilities", description: "(As-Is)" },
  { id: 9, image: EM, title: "Engagement Models"},


  // { id: 8, image: ser, title: "Technology Services", description: "Digital transformation" },
]

export default function Offerings() {
  const [activeIndex, setActiveIndex] = useState(0)
  const swiperRef = useRef(null)
  const navigate = useNavigate() 

  const handleNavigate = (productName) => {
    navigate("/individualPages", { state: { productName } })
  }

  const handleSlideChange = (swiper) => {
    setActiveIndex(swiper.realIndex)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (swiperRef.current?.autoplay) {
        swiperRef.current.autoplay.start()
      }
    }, 50) 

    return () => clearTimeout(timer)
  }, [])

  return (
    <div className="offerings-container">
      

     <section className="offerings-hero-section">
  <div className="container">
    <p className="letter-spacing text-uppercase fw-bold mb-3">Welcome to Blukraft</p>
    <h1 style={{ color: '#6e0e5e' ,textAlign:'center'}}>Unleashing Potential</h1>
  </div>
</section>

      <section className="offerings-carousel-section">
        <div className="container-lg">
          <Swiper
            onSwiper={(swiper) => { 
              swiperRef.current = swiper 
              // ✅ INSTANT AUTOPLAY START
              setTimeout(() => swiper.autoplay?.start(), 100)
            }}
            onSlideChange={handleSlideChange}
            effect="coverflow"
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={3}
            spaceBetween={30}
            speed={250}           // ✅ ULTRA-FAST: 250ms
            coverflowEffect={{
              rotate: 0,
              stretch: 0,
              depth: 200,
              modifier: 1,
              slideShadows: false,
            }}
            loop={true}
            autoplay={{
              delay: 2000,          // ✅ SUPER-FAST: 2 seconds
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            pagination={{ clickable: true }}
            modules={[EffectCoverflow, Pagination, Autoplay]}
            className="bcg-swiper"
          >
            {carouselData.map((item, idx) => (
              // <SwiperSlide key={item.id}>
              //   <div className={`carousel-slide ${idx === activeIndex ? 'active' : ''}`}>
              //     <div className="carousel-image">
              //       <img src={item.image} alt={item.title} />
              //     </div>
              //     <div className="carousel-content">
              //       <h3>{item.title}</h3>
              //       <p>{item.description}</p>
              //     </div>
              //   </div>
              // </SwiperSlide>
              <SwiperSlide key={item.id}>
  <div className={`carousel-slide ${idx === activeIndex ? 'active' : ''}`}>
    <div className="carousel-image">
      <img src={item.image} alt={item.title} />
      
      {/* ✅ Hover overlay - full image coverage */}
      {idx === activeIndex && (
        <div className="hover-overlay">
          <div className="overlay-content">
            <h3>{item.title}</h3>
            <p>{item.description}</p>
            <button 
                            className="learn-more-btn"
                            onClick={() => handleNavigate(item.title)}
                          >
                            Learn More
                          </button>
          </div>
        </div>
      )}
    </div>
    
    {/* ✅ White content bar - DISAPPEARS on hover */}
    {idx === activeIndex && (
      <div className="carousel-content">
        <h3>{item.title}</h3>
        <p>{item.description}</p>
      </div>
    )}
  </div>
</SwiperSlide>

            ))}
          </Swiper>
        </div>
      </section>
      
    </div>
  )
}
